/// <reference path="index.d.ts" />
import * as React from 'react';
import { resetUrl } from '../../common/reset-image';
import * as classnames from "classnames";
import doLog from '../../common/log';
interface PropTypes {
  mediaItems: [ImageInterface];
  activedId: number;
  handleClick: ( index: number ) => void;
}

function SlideList ( props: PropTypes ) {
  const { mediaItems,activedId,handleClick } = props;

  // 如果有证书优先展示
  const renderItem = ( item: ImageInterface,index: number ) => {
    const itemStyleName = classnames( {
      'slider-item': true,
      'actived': index === activedId
    } );
    
    return (
      <div className={itemStyleName} key={index} onClick={e => {
        e.stopPropagation();
        doLog(
          '/sc.details.commonLogs',
          `action=mainImageDialogThumbClick&info=${index}`,
        );
        handleClick( index );
      }}>
        <img loading='lazy' src={resetUrl( item?.item?.certLogoUrl || item.url,'250' )} />
      </div> );
  };
  const overlayout = classnames( {
    "slider-list": true,
    "over-layout": mediaItems.length > 12
  } );
  return (
    <div className={overlayout}>
      {mediaItems.map( ( item,index ) => renderItem( item,index ) )}
    </div>
  );
}

export default SlideList;
